import { RefundPassenger } from '../model/passengers/types';

export const getRefundChildIds = (passenger: RefundPassenger) => passenger.children?.map(child => child.id) ?? [];

const getFamilyLabel = (adult: RefundPassenger): string => {
	const childrenNames = adult.children
		?.map(child => child.values.fullName)
		.filter(Boolean)
		.join(', ');

	return childrenNames ? `${adult.values.fullName}, ${childrenNames}` : adult.values.fullName;
};

export const getRefundPassengerLabel = (passenger: RefundPassenger): string => {
	if (passenger.type === 'ADT' && passenger.children?.length) {
		return getFamilyLabel(passenger);
	}

	return passenger.values.fullName;
};
